/**
 * Test IDs for QA automation.
 */
export const testIds = {
  ratingTableEditorLabel: "rating-table-editor-label",
  ratingTableEditorDescription: "rating-table-editor-description",
  ratingTableEditorReferenceNumber: "rating-table-editor-reference-number",
  ratingTableEditorPriority: "rating-table-editor-priority",
  ratingTableEditorActive: "rating-table-editor-active",
  ratingTableEditorRowAxisTarget: "rating-table-editor-row-axis-target",
  ratingTableEditorRowAxisTargetOption: "rating-table-editor-row-axis-target-option",
  ratingTableEditorRowAxisOperator: "rating-table-editor-row-axis-operator",
  ratingTableEditorRowAxisOperatorOption: "rating-table-editor-row-axis-operator-option",
  ratingTableEditorColumnAxisTarget: "rating-table-editor-column-axis-target",
  ratingTableEditorColumnAxisTargetOption: "rating-table-editor-column-axis-target-option",
  ratingTableEditorColumnAxisOperator: "rating-table-editor-column-axis-operator",
  ratingTableEditorColumnAxisOperatorOption: "rating-table-editor-column-axis-operator-option",
  ratingTableEditorAddColumnAxis: "rating-table-editor-add-column-axis",
  ratingTableEditorRemoveColumnCondition: "rating-table-editor-remove-column-condition",
  ratingTableEditorAddColumnCondition: "rating-table-editor-add-column-condition",
  ratingTableEditorDelete: "rating-table-editor-delete",
  ratingTableEditorAddRowCondition: "rating-table-editor-add-row-condition",
  ratingTableEditorCancel: "rating-table-editor-cancel",
  ratingTableEditorSaveChanges: "rating-table-editor-save-changes",
} as const;
